import type { FC } from "react";
import React, { useMemo } from "react";
import type { ListChildComponentProps } from "react-window";
import { useTheme } from "styled-components";

import { BoardOption } from "@/components/QuickSearch/components/BoardDropdown/components/BoardOption";
import { LoaderOption } from "@/components/QuickSearch/components/DropdownList/components/LoaderOption";
import { NoResultsOption } from "@/components/QuickSearch/components/DropdownList/components/NoResultsOption";
import type { PolymorphicBoardOption } from "@/components/QuickSearch/hooks/usePolyBoardOptions";
import { BoardOptionType } from "@/components/QuickSearch/hooks/usePolyBoardOptions";
import { getVirtualizedProps } from "@/components/QuickSearch/utils/getVirtualizedProps";
import { get } from "@/utils/theme-gets";

export const BoardPolyOptionVirtualized: FC<ListChildComponentProps<PolymorphicBoardOption[]>> = (props) => {
  const theme = useTheme();
  const virtualizedProps = getVirtualizedProps(props);

  const styleWithPadding = useMemo(() => {
    return {
      ...props.style,
      top: `calc(${props.style.top}px + ${get(theme, "spacing.s", null) as null})`,
    };
  }, [props.style, get(theme, "spacing.s", null)]);

  switch (virtualizedProps.type) {
    case BoardOptionType.Board:
      return <BoardOption virtualizedStyle={styleWithPadding} index={props.index} {...virtualizedProps} />;
    case BoardOptionType.IsLoading:
      return <LoaderOption virtualizedStyle={styleWithPadding} index={props.index} text="Loading boards..." />;
    case BoardOptionType.NoBoards:
      return <NoResultsOption virtualizedStyle={styleWithPadding} index={props.index} />;
  }
};
